/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Pagination from "../../../../Helper/Pagination";
import MoonLoader from "react-spinners/MoonLoader";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function EmailTemplate() {
  const [List, setList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [id, setid] = useState("");
  const [Title, setTitle] = useState("");
  const [Subject, setSubject] = useState("");
  const [Description, setDescription] = useState("");
  const [submitLoader, setsubmitLoader] = useState(false);

  useEffect(() => {
    getTemplateList();
  }, [search_key, currentPage]);

  const getTemplateList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_QUESTIONS_LIST, param).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setList(res?.data?.data?.rows);
        SetTotalPageCount(res.data.totalPages);
        SetTotalCount(res.data.totalItems);
        setCount(res.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  function Delete(id, name) {
    const data = {
      id: id,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_QUESTIONS, data).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getTemplateList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  const [selectedData, setSelectedData] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    setTitle(selectedData?.title);
    setSubject(selectedData?.subject);
    setDescription(selectedData?.description || "");
    setid(selectedData?.id ? selectedData?.id : "");
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();
    console.log("sdj");

    if (!Subject || !Description || !Title) {
      setError(true);
      return;
    }

    setsubmitLoader(true);
    const data = {
      title: Title,
      subject: Subject,
      description: Description,
    };
    if (selectedData?.id) {
      data.id = selectedData?.id;
    }
    const route = selectedData?.id
      ? API_URL.UPDATE_QUESTIONS
      : API_URL.CREATE_QUESTION_LIST;

    PostService(route, data).then(
      (res) => {
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getTemplateList);
          resetFunc();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
          setsubmitLoader(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setsubmitLoader(false);
      }
    );
  };

  function resetFunc() {
    setid("");
    setTitle("");
    setSubject("");
    setDescription("");
    setError(false);
    setsubmitLoader(false);
    setSelectedData("");
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Email Template List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">
                  Email Template List
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="align-items-center d-flex justify-content-end row">
                    <div className="col-md-8 p-0">
                      <div className="ml-4">
                        <button
                          className="btn btn-primary py-2"
                          data-toggle="modal"
                          data-target="#EditModal"
                          onClick={resetFunc}
                        >
                          Add Template
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4 p-0">
                      <nav className="navbar">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Title"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive mt-3">
                    {!loading && (
                      <table className="table table-hover text-nowrap table-striped table-bordered">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Title</th>
                            <th className="text-center">Subject</th>
                            <th className="text-center">Description</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {List?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td>{i + S_No_Count + 1}</td>
                              <td>{data?.title}</td>
                              <td
                                style={{
                                  whiteSpace: "break-spaces",
                                  lineHeight: "1.2",
                                }}
                              >
                                {data?.subject}
                              </td>
                              <td>{data?.description}</td>
                              <td className="text-center">
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                                <span
                                  title="Delete"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  onClick={() => {
                                    Delete(data?.topquestionid, "Question");
                                  }}
                                >
                                  <i className="text-danger fas fa-trash"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                          {List && List.length === 0 && (
                            <tr>
                              <td colSpan="9" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------EDIT MODAL START---------- */}

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                {selectedData?.id ? "Update Template" : "Add Template"}
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <label>Title</label>
                    <input
                      type="text"
                      name="Title"
                      value={Title}
                      className="form-control"
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Enter Title"
                      disabled={selectedData?.Title}
                    /> 
                    {error && !Title && (
                      <div className="error">Title cannot be empty</div>
                    )}
                  </div>
                  <div className="col-12 mt-3">
                    <label>Subject</label>
                    <input
                      type="text"
                      name="Subject"
                      value={Subject}
                      className="form-control"
                      onChange={(e) => setSubject(e.target.value)}
                      placeholder="Enter Subject"
                    />
                    {error && !Subject && (
                      <div className="error">Subject cannot be empty</div>
                    )}
                  </div>

                  <div className="col-12 mt-3">
                    <label>Description</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={Description}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setDescription(data);
                      }}
                    />
                    {error && !Description && (
                      <div className="error">Description cannot be empty</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary py-2"
                  id="closeEditModal"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary py-2"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : selectedData?.id ? (
                    "Update"
                  ) : (
                    "Add"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
